import React, { useState } from 'react';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { resetPassword } from '../auth/authApi';
import { isPasswordStrong } from '../utils/passwordUtils';

const ResetPasswordLayer = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token') || '';
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) {
      setError('Passwords do not match');
      return;
    }
    if (!isPasswordStrong(password)) {
      setError('Password must be 8+ chars, include uppercase, 2 numbers and a symbol');
      return;
    }
    try {
      await resetPassword({ token, password });
      navigate('/sign-in');
    } catch (err) {
      setError('Unable to reset password. Please contact support.');
    }
  };

  return (
    <div
      className='signup-page-background'
      style={{
        backgroundColor: '#f7f7f7',
        height: '100vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
      }}
    >

      {/* Header */}
      <header
        className="shadow-sm py-3 px-24 d-flex align-items-center"
      >
        <Link to="/" className="d-inline-block">
          <img
            src="/assets/images/logo_neg.png"
            alt="Logo"
            style={{ height: '40px', objectFit: 'contain' }}
          />
        </Link>
      </header>

      {/* Main Content */}
      <section
        className="auth forgot-password-page d-flex justify-content-center pt-4 px-3"
        style={{
          flex: 1,
          overflowY: 'auto',
          minHeight: 0,
        }}
      >
        <div className="d-flex flex-column">
          <div 
            className="p-32 m-32 border rounded-2 text-center bg-white"
            style={{ width: '500px' }}
            >
            <>
              <div className="text-center p-16 d-flex flex-column align-items-center">
                <div
                  className="d-flex align-items-center justify-content-center rounded-circle mb-32 bg-primary-100 text-primary"
                  style={{ width: "90px", height: "90px" }}
                >
                  <Icon icon='mdi:lock-reset' style={{ fontSize: "54px" }} />
                </div>
              </div>
              <div>
                <h5 className="mb-24">Reset Password</h5>
                <p className="mb-32 text-secondary-light text-lg">
                  Enter your new password below.
                </p>
              </div>
              <form onSubmit={handleSubmit}>
                <div className="icon-field mb-16 text-start">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type="password"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="New Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <div className="icon-field  text-start">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="solar:lock-password-outline" />
                  </span>
                  <input
                    type="password"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="Confirm Password"
                    value={confirm}
                    onChange={(e) => setConfirm(e.target.value)}
                    required
                  />
                </div>
                {error && <div className="text-danger mt-3">{error}</div>}
                <button
                  type="submit"
                  className="btn btn-primary text-sm btn-sm px-12 py-12 w-50 radius-12 mt-32"
                >
                  Reset Password
                </button>
                <div className="mt-120 text-center text-sm">
                  <p className="mb-0">
                    <Link to="/sign-in" className="text-primary-600 fw-semibold">
                      Back to Sign In
                    </Link>
                  </p>
                </div>
              </form>
            </>
          </div>
        </div>
      </section>
      <footer className="text-center py-3">
        <small className="text-white">© {new Date().getFullYear()} Samurai CMMS</small>
      </footer>
    </div>
  );
};

export default ResetPasswordLayer;
